import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue";
var _hoisted_1 = {
  "class": "leader-board-container"
};
var _hoisted_2 = {
  "class": "w-full h-full flex justify-center items-strech bg-lilac"
};
var _hoisted_3 = {
  "class": "flex-1 h-full flex flex-col justify-center items-center gap-4"
};
var _hoisted_4 = {
  "class": "text-center"
};
var _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", {
  "class": "text-white mb-2 leaderboard"
}, "LIVE COUNTER", -1);
var _hoisted_6 = {
  "class": "main-counter pl-3"
};
var _hoisted_7 = {
  "class": ""
};
var _hoisted_8 = {
  "class": "leaderboard"
};
var _hoisted_9 = {
  "class": "text-seagreen mt-2 leaderboard"
};
var _hoisted_10 = {
  "class": "text-center"
};
var _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", {
  "class": "text-white mb-2 leaderboard"
}, "TARGET TODAY", -1);
var _hoisted_12 = {
  "class": "rounded-md text-center bg-seagreen"
};
var _hoisted_13 = {
  "class": "leaderboard"
};
var _hoisted_14 = {
  "class": "w-1/3 h-full bg-lilacdark flex flex-col justify-center items-center"
};
var _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"w-full flex justfy-between items-center gap-2\"><div class=\"w-1/2 p-1 pl-3\"><span class=\"text-2xl text-white\">SCORECARD</span></div><div class=\"w-1/2 bg-seagreen p-1 text-center\"><span class=\"text-2xl\">TOP TEAMS</span></div></div>", 1);
var _hoisted_16 = {
  "class": "w-full flex justify-between items-center gap-2 bg-slate-800 pl-3"
};
var _hoisted_17 = /*#__PURE__*/_createElementVNode("span", {
  "class": "text-3xl text-white"
}, "ALL TIME", -1);
var _hoisted_18 = {
  "class": "text-3xl text-white text-center"
};
var _hoisted_19 = {
  "class": "w-full flex justify-between items-strech gap-2 bg-seagreen border-b border-lilacdark"
};
var _hoisted_20 = {
  "class": "text-3xl text-white text-center bg-lilacdarker w-10 py-3"
};
var _hoisted_21 = {
  "class": "flex-1 flex flex-col leaderboard"
};
var _hoisted_22 = {
  "class": "text-3xl py-3"
};
var _hoisted_23 = {
  "class": "text-[32px] text-lilac text-center w-20 bg-white py-3"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    title: "LeaderBoard"
  }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.liveCounterData.achived_array, function (achived) {
    return _openBlock(), _createElementBlock("span", _hoisted_7, [_createElementVNode("h1", _hoisted_8, _toDisplayString(achived), 1)]);
  }), 256))]), _createElementVNode("h3", _hoisted_9, _toDisplayString($data.liveCounterData.remaining) + " TO GO", 1)]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("h2", _hoisted_13, _toDisplayString($data.liveCounterData.target), 1)])])]), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, _toDisplayString($data.record.cnt) + " by " + _toDisplayString($data.record.team_name), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.teamLeaderboard, function (team, team_key) {
    return _openBlock(), _createElementBlock("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(team_key + 1), 1), _createElementVNode("div", _hoisted_21, [_createElementVNode("span", _hoisted_22, _toDisplayString(team.team_name), 1)]), _createElementVNode("div", _hoisted_23, _toDisplayString(team.cnt), 1)]);
  }), 256))])])]);
}